import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function withNavigate(Component) {
  function ComponentWithNavigate(props) {
    const navigate = useNavigate();
    const location = useLocation()
    return <Component {...props} navigate={navigate} location={location} />;
  }
  ComponentWithNavigate.displayName = `withNavigate(${Component.displayName || Component.name})`;
  return ComponentWithNavigate;
}
